<template>
    <el-tabs v-model="activeName">
		<el-tab-pane label="密码" name="password" v-if="showPWD">
            <PassWord
                ref="password"
                :params="params"
                @overTime="cancel"
				@submit="submit"
            />
        </el-tab-pane>
        <el-tab-pane label="短信" name="sms" v-if="showSms">
            <Sms
                ref="sms"
                :params="params"
                @overTime="cancel"
				@submit="submit"
            />
        </el-tab-pane>
        <el-tab-pane label="邮箱" name="email" v-if="showEmail">
            <Email
                ref="email"
                :params="params"
                @overTime="cancel"
				@submit="submit"
            />
        </el-tab-pane>
        <el-tab-pane label="GOOGLE验证器" name="google" v-if="showGoogle">
            <Google
                ref="google"
                :params="params"
                @overTime="cancel"
				@submit="submit"
            />
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import Sms from "./components/Sms";
import Email from "./components/Email";
import Google from "./components/Google";
import PassWord from "./components/PassWord";

export default {
	name: "Verify",
	components: {
		Sms,
		Email,
		Google,
		PassWord
	},
	data() {
		return {
			types: ["sms", "email", "google"],
			// 可用类型
			showTypes: ["sms", "email", "google"],
			activeName: "password",
            params: {
				// phoneNumber,
				// email,
				// bit,
				// key,
			}
		};
	},
	computed: {
		showSms() {
			return this.showTypes.includes("sms");
		},
		showEmail() {
			return this.showTypes.includes("email");
		},
		showGoogle() {
			return this.showTypes.includes("google");
		},
		showPWD() {
			return !this.showTypes || this.showTypes.length === 0;
		}
	},
	watch: {
		showTypes: {
			handler(newValue) {
				console.log(newValue);
				if (!newValue || newValue.length === 0) {
					this.activeName = "password";
					return;
				}
				this.activeName = newValue[0];
			},
		},
	},
	methods: {
		init(types, data) {
            this.params = data;
			this.showTypes = types;
		},
        getCode() {
			console.log(this.activeName);
			let rs = this.$refs[this.activeName].getCode();
			if (!rs.code) {
				this.$message.error("验证码不能为空");
				return false;
			}
            return this.$refs[this.activeName].getCode();
        },
        cancel() {
			this.$emit("onCancel");
		},
		submit(){
			this.$emit("submit");
		}
	}
};
</script>

<style lang="scss" scoped>
.title{
	font-size: 22px;
	text-align: left;
	margin-bottom: 10px;
}
.sub_title {
	font-size: 12px;
	text-align: left;
	margin-bottom: 10px;
	color: gray;
}
.grid {
	font-size: 14px;
	display: grid;
	grid-template-columns: 100px 200px 20px;
	align-items: center;
}
</style>